import {styled} from '@mui/material/styles';

import {ReactComponent as Logo} from '@explorer/assets/logos/logo-dark.svg';

const PlanetLogo = styled(Logo)(({theme}) => ({
  height: '3.5rem',
  width: '7rem',
  display: 'block',
  marginBottom: theme.spacing(3),
}));

export default PlanetLogo;
